import { useMemo, useEffect } from 'react';
import { subscriptionStore } from '@/stores/SubscriptionStore';
import { formatCurrency } from '@/utils/currency';

const frequencyLabels: Record<string, string> = {
  weekly: 'week',
  monthly: 'month',
  yearly: 'year',
};

export function usePolicyText() {
  useEffect(() => {
    if (subscriptionStore.plans.length === 0) {
      void subscriptionStore.fetchPlans();
    }
  }, []);

  const trialPlan = subscriptionStore.selectedTrialPlan;
  const trialDays = trialPlan?.trial?.periodDays ?? 3;
  const billingFrequencyLabel
    = frequencyLabels[trialPlan?.billingFrequency ?? 'weekly']
      ?? (trialPlan?.billingFrequency ?? 'week');

  const trialPriceFormatted = useMemo(() => {
    const amount
      = trialPlan?.trial?.firstCharge
        ?? trialPlan?.discount?.discountedPrice
        ?? trialPlan?.price
        ?? '__';
    return formatCurrency(amount, trialPlan?.currency ?? 'usd');
  }, [trialPlan]);

  const recurringPriceFormatted = useMemo(() => {
    const amount = trialPlan?.price ?? '__';
    return formatCurrency(amount, trialPlan?.currency ?? 'usd');
  }, [trialPlan]);

  return {
    trialDays,
    billingFrequencyLabel,
    trialPriceFormatted,
    recurringPriceFormatted,
  };
}
